import { defineStore } from 'pinia';
import { useBookingStore } from './bookingStore';
import { useMainStore } from './mainStore';
import Equipe from '@/classes/Equipe/Equipe.class';

export const useEquipesStore = defineStore('equipes', {
    state: () => ({
        list: [],

    }),
    actions: {
        assign_teams(add_missing_inscriptions = false) {

            const bookingStore = useBookingStore();
            const coureurs_to_assign = this.get_coureurs_to_assign();
            const new_equipes_created = this.build_equipes(coureurs_to_assign);
            if (add_missing_inscriptions) {
                bookingStore.handleCreatedTeams(new_equipes_created);
            }
        },

        clearState() {
            this.list = [];
        },

        get_coureurs_to_assign() {
            const bookingStore = useBookingStore();
            const inscriptions = bookingStore.inscriptions;
            if (!inscriptions) return [];
            let coureurs_to_assign = [];
            for (let i = 0; i < inscriptions.length; i++) {
                const inscription = inscriptions[i];
                let need_to_be_assign = false;
                const courses = inscription.get_courses();
                for (let j = 0; j < courses.length; j++) {
                    const course = courses[j];
                    if (course.is_equipe_course()) {
                        coureurs_to_assign.push({
                            index: i,
                            coureur: inscription.coureur.get_nom(),
                            course: course.id,
                            course_nom: course.nom,
                            size: course.get_equipe_size(),
                            equipe: inscription.get_equipe_name(),
                            extra_fields_equipe: inscription.get_extra_fields_equipe(),
                        });
                        need_to_be_assign = true;
                    }
                }
                if (!need_to_be_assign) {
                    delete inscriptions[i].coureur.equipe_name;
                }
            }
            return coureurs_to_assign;

        },


        build_equipes(coureurs_to_assign) {
            const coureurs_with_equipes = coureurs_to_assign.filter((coureur) => coureur.equipe != "");
            const coureurs_without_equipes = coureurs_to_assign.filter((coureur) => coureur.equipe == "");
            this.list = [];
            const new_equipes_created = this.handle_coureurs_with_equipes(coureurs_with_equipes);
            const new_equipes_created_without_equipes = this.handle_coureurs_without_equipes(coureurs_without_equipes, new_equipes_created);
            return new_equipes_created.concat(new_equipes_created_without_equipes);
        },

        handle_coureurs_with_equipes(coureurs_with_equipes) {
            let new_equipes_created = [];
            for (let i = 0; i < coureurs_with_equipes.length; i++) {
                const coureur = coureurs_with_equipes[i];
                if (this.equipe_already_exist(coureur.equipe, coureur.course)) {
                    this.assign_coureur_to_equipe(coureur);
                } else {
                    const new_equipe = this.create_new_equipe(coureur);
                    if (new_equipe) {
                        new_equipes_created.push(new_equipe);
                    }
                }
            }
            return new_equipes_created;
        },

        assign_coureur_to_equipe(coureur) {
            for (let i = 0; i < this.list.length; i++) {
                let equipe = this.list[i];
                if (equipe.nom == coureur.equipe && equipe.size > equipe.coureurs.length && equipe.id_course == coureur.course) {
                    equipe.coureurs.push({ index: coureur.index, name: coureur.coureur });
                }
            }
        },

        create_new_equipe(coureur) {
            const mainStore = useMainStore();
            let new_equipe = new Equipe();
            new_equipe.nom = coureur.equipe;
            new_equipe.size = coureur.size;
            new_equipe.id_course = coureur.course;
            new_equipe.nom_course = coureur.course_nom;
            new_equipe.coureurs.push({ index: coureur.index, name: coureur.coureur });
            new_equipe.set_extra_fields(mainStore.module.base, coureur.extra_fields_equipe);
            this.list.push(new_equipe);
            const new_equipe_created = { size: new_equipe.size, id_course: new_equipe.id_course, nom: new_equipe.nom, nom_course: new_equipe.nom_course };
            return new_equipe_created;
        },

        handle_coureurs_without_equipes(coureurs_without_equipes) {
            let bookingStore = useBookingStore();
            let new_equipes_created = [];
            for (let i = 0; i < coureurs_without_equipes.length; i++) {
                const coureur = coureurs_without_equipes[i];
                let assign = false;
                for (let j = 0; j < this.list.length; j++) {
                    let equipe = this.list[j];
                    if (equipe.size > equipe.coureurs.length && equipe.id_course == coureur.course) {
                        bookingStore.inscriptions[coureur.index].set_equipe_name(equipe.nom);
                        equipe.coureurs.push({ index: coureur.index, name: coureur.coureur });
                        assign = true;
                        break;
                    }
                }
                if (!assign) {
                    const new_equipe = this.create_new_equipe(coureur);
                    if (new_equipe) {
                        new_equipes_created.push(new_equipe);
                    }
                }
            }
            return new_equipes_created;
        },

        /**
         * Checks if a team already exists in the list of teams for a given course and has available spots.
         *
         * @param {string} nom_equipe - The name of the team to check.
         * @param {number} id_course - The ID of the course to check.
         * @returns {boolean} - Returns true if the team exists and has available spots, otherwise false.
         */
        equipe_already_exist(nom_equipe, id_course) {
            return this.list.filter((equipe) => equipe.nom == nom_equipe && equipe.size > equipe.coureurs.length && equipe.id_course == id_course).length > 0;
        }
    },
    getters: {
        has_equipes() {
            return this.list.length > 0;
        },
        equipes_have_valid_names() {
            if (!this.has_equipes) return true;
            return this.all_coureurs_have_equipe_name && this.all_equipes_have_valid_name;
        },
        equipes_are_full() {
            const mainStore = useMainStore();
            if (mainStore.authAdmin.hasSuperAdminRights) return true;
            if (!this.has_equipes) return true;
            for (let i = 0; i < this.list.length; i++) {
                if (this.list[i].size > this.list[i].coureurs.length) {
                    return false;
                }
            }
            return true;
        },

        equipes_valid_for_ANH26() {
            if (!this.has_equipes) return true;
            const bookingStore = useBookingStore();
            const mainStore = useMainStore();

            // Si le module n'est pas chargé ou n'a pas de courses, on retourne true
            if (!mainStore.module || !mainStore.module.courses || !mainStore.module.courses.list) {
                return true;
            }

            for (let i = 0; i < this.list.length; i++) {
                const equipe = this.list[i];

                // Trouver la course correspondante
                const course = mainStore.module.courses.list.find(c => c.id == equipe.id_course);
                if (!course) continue;

                // Vérifier si la course exige que l'équipe soit mixte
                const has_to_be_mixte = course?.metadatas?.regle_mineur_anh26 == "1";
                if (!has_to_be_mixte) continue;

                // Si l'équipe n'est pas complète, on ne peut pas vérifier le mixte
                if (equipe.size > equipe.coureurs.length) continue;

                // vérifiquer qu'il y a au moins 1 majeur pour 3 mineurs
                let nb_mineurs = 0;
                let nb_majeurs = 0;
                for (let j = 0; j < equipe.coureurs.length; j++) {
                    const coureur_index = equipe.coureurs[j].index;
                    if (bookingStore.inscriptions[coureur_index] && bookingStore.inscriptions[coureur_index].coureur) {
                        const coureur = bookingStore.inscriptions[coureur_index].coureur;
                        if (coureur.is_mineur()) {
                            nb_mineurs++;
                        } else {
                            nb_majeurs++;
                        }
                    }
                }
                if (nb_mineurs == 0) {
                    return true;
                }
                if (nb_majeurs == 0) {
                    return false;
                }
                let ratio = nb_mineurs / nb_majeurs;
                ratio = parseFloat(ratio.toFixed(2));

                if (ratio < 3) {
                    return false;
                }
            }
            return true;
        },

        has_different_vagues() {
            if (!this.has_equipes) return true;
            const mainStore = useMainStore();
            const bookingStore = useBookingStore();

            for (let i = 0; i < this.list.length; i++) {
                const equipe = this.list[i];
                const course = mainStore.module.courses.list.find(c => c.id == equipe.id_course);
                if (!course) continue;
                if (!course.has_vagues()) continue;
                let vagues_representes = [];
                for (let j = 0; j < equipe.coureurs.length; j++) {

                    const coureur_index = equipe.coureurs[j].index;
                    const inscription = bookingStore.inscriptions[coureur_index];
                    if (!inscription) continue;
                    // trouver la course selectionnée par l'inscription
                    const course_selectionnee = inscription.list_courses.list.find(c => c.id == course.id);
                    if (!course_selectionnee) continue;
                    const vague = course_selectionnee.vague_selected;
                    if (!vagues_representes.includes(vague)) {
                        vagues_representes.push(vague);
                    }
                }
                if (vagues_representes.length > 1) {
                    return false;
                }
            }
            return true;
        },

        equipes_have_valid_sexes() {
            if (!this.has_equipes) return true;

            const bookingStore = useBookingStore();
            const mainStore = useMainStore();

            // Si le module n'est pas chargé ou n'a pas de courses, on retourne true
            if (!mainStore.module || !mainStore.module.courses || !mainStore.module.courses.list) {
                return true;
            }

            for (let i = 0; i < this.list.length; i++) {
                const equipe = this.list[i];

                // Trouver la course correspondante
                const course = mainStore.module.courses.list.find(c => c.id == equipe.id_course);
                if (!course) continue;

                // Vérifier si la course exige que l'équipe soit mixte
                const has_to_be_mixte = course?.metadatas?.obligatoire_mixte == "1";
                if (!has_to_be_mixte) continue;

                // Si l'équipe n'est pas complète, on ne peut pas vérifier le mixte
                if (equipe.size > equipe.coureurs.length) continue;

                // Vérifier que l'équipe contient au moins deux sexes différents
                let sexe_representes = [];
                for (let j = 0; j < equipe.coureurs.length; j++) {
                    const coureur_index = equipe.coureurs[j].index;
                    if (bookingStore.inscriptions[coureur_index] && bookingStore.inscriptions[coureur_index].coureur) {
                        const coureur = bookingStore.inscriptions[coureur_index].coureur;
                        const sexe = coureur.get_field_value_by_name("sexe");
                        if (sexe && !sexe_representes.includes(sexe)) {
                            sexe_representes.push(sexe);
                        }
                    }
                }

                // Si un seul sexe est représenté, l'équipe n'est pas valide
                if (sexe_representes.length < 2) {
                    return false;
                }
            }

            return true;
        },
        equipes_have_fields() {
            if (!this.has_equipes) return true;
            for (let i = 0; i < this.list.length; i++) {
                if (!this.list[i].has_complete_all_fields()) {
                    return false;
                }
            }
            return true;
        },

        all_coureurs_have_equipe_name() {
            const bookingStore = useBookingStore();
            for (let i = 0; i < bookingStore.inscriptions.length; i++) {
                let inscription = bookingStore.inscriptions[i];
                let courses = inscription.get_courses();
                for (let j = 0; j < courses.length; j++) {
                    let course = courses[j];
                    if (course.is_equipe_course()) {
                        if (inscription.coureur.equipe_name == "") {
                            return false;
                        }
                    }
                }
            }
            return true;
        },
        all_equipes_have_valid_name() {
            for (let i = 0; i < this.list.length; i++) {
                const nom_equipe = this.list[i].nom;
                if (nom_equipe == "") {
                    return false;
                }
                const authorizedPattern = /^[A-Z0-9+\-=/*#@%!?£€({[\]})|. ]+$/;
                // Check if the input string matches the authorized pattern
                if (authorizedPattern.test(nom_equipe)) {
                    // String contains only authorized characters
                    return true;
                } else {
                    // Find the first unauthorized character
                    const unauthorizedCharacter = nom_equipe.match(/[^A-Z0-9+\-=/*#@%!?£€({[\]})|. ]/)[0];
                    if (unauthorizedCharacter.match(/[a-z]/)) return false;
                    if (unauthorizedCharacter.match(/[ÀÁÂÃÄÅàáâãäåÈÉÊËèéêëÌÍÎÏìíîïÒÓÔÕÖØòóôõöøÙÚÛÜùúûü]/)) return false;
                    return false;
                }
            }
        }

    }
});